import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logoSiloam from "../../assets/logo_siloam.png";
import bg from "../../assets/bg_sos.jpg";
import imgHeader from "../../assets/header_sos.png";
import PopupAdd from "../../components/popup_add";
import ModalImage from "react-modal-image";
import CONFIG from "../../constanta/config";

const PageHotel = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="relative w-full md:w-[500px] mx-auto h-screen flex flex-col justify-betwstarteen items-start ">
        <img
          src={bg}
          className="absolute z-10 w-full h-full mx-auto object-cover"
          alt=""
        />

        <img
          src={imgHeader}
          className="absolute z-50 top-0 w-full object-contain mx-auto object-cover"
          alt=""
        />

        <div className="overflow-x-hidden z-10 relative flex flex-grow w-full h-auto justify-center items-start px-5 pb-5 pt-20">
          <div className="flex flex-col justify-center items-center pb-20 w-full space-y-6">
            <div className="w-full h-auto bg-white border-2 border-white rounded-lg p-2 ">
              <div className="font-bold text-lg text-center">
               HOTEL
              </div>
              
            </div>

            <div className="w-full h-auto bg-white border-2 border-white rounded-lg p-4 ">
              <ModalImage
                small={CONFIG.URL_MEDIA + "/hotel_1.png"}
                large={CONFIG.URL_MEDIA + "/hotel_1.png"}
                alt=""
              />
            </div>

            <div className="w-full flex justify-center items-center space-x-5 my-5">
              <button
                onClick={() => navigate("/event-info")}
                className="w-full px-5 py-2 bg-transprent border-2 border-red-500 rounded-lg text-white font-bold"
              >
                BACK
              </button>
            </div>
          </div>
        </div>

       
      </div>
    </>
  );
};

export default PageHotel;
